import React, { Component } from "react";
import "../App.css";
import { Well } from "react-bootstrap";

class ViabilityBox extends Component {
  render() {
    const viability = this.props.viability;
    const loading = this.props.loading;
    const color = this.props.color;
    return (
      <Well id="risks">
        <div className="summary_viability_container">
          <div className="summary_viability_title">VIABILITY SCORE</div>
          {!loading && (
            <div className="summary_viability_score">
              <span style={{ color: color }}>{viability + "%"}</span>
            </div>
          )}
          {loading && (
            <div className="risks_loading_container">
              <div className="loader">
                <div className="lds-ellipsis">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          )}
        </div>
      </Well>
    );
  }
}

export default ViabilityBox;



// WEBPACK FOOTER //
// ./client/src/components/ViabilityBox.js